/* eslint-disable @nx/enforce-module-boundaries */
import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Image,
  HStack,
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Stack,
  Flex,
  Avatar,
} from '@mybridge/ui';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Tooltip } from '@mybridge/ui';
import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import {
  CalendarIcon,
  EventDashbaord,
  EyeViewIcon,
  MyBridgeIcon,
  Pencil,
  ThreeDotsIcon,
  VerticalThreeDot,
} from '@mybridge/icons';
import moment from 'moment-timezone';
import Link from 'next/link';
import { postDelete } from 'v4/store/actions/post.actions';
import { useToast } from '@mybridge/ui';
import { getUserFullName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

const EventListRow = ({ event, type, isDeleted,setTabIndex }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const toast = useToast();
  const { t } = useTranslator();
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const handleDeleteEvent = () => {
    dispatch(postDelete({ id: event?.id })).then((res) => {
      if (res) {
        toast({
          title: t('myEvents.eventDeletedSuccessfully') || 'Event deleted successfully',
          position: 'top',
          status: 'success',
          isClosable: true,
        });
        setTabIndex(type==="past"?1:0)
        isDeleted(true);
        // router.push(`/myevents`);
      }
    });
  };
  
  const isValidUrl = (url) => {
    if (url==="builtin")return true
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)' + // Protocol must be present (http or https)
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // Domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // Port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // Query string
      '(\\#[-a-z\\d_]*)?$',
      'i'
    );       
    return urlPattern.test(url);
  };

  const handleGetEventDetails=(eventDetails)=>{
    if (eventDetails) {
      let computedUrl = '';
      // Determine the URL based on location_type and location properties
      switch (eventDetails.location_type) {
        case 'builtin':
          computedUrl = `/myevents/join/${eventDetails.id}`;
          setIsButtonVisible(true);
          break;
        case 'google_meet':
        case "zoom":
        case 'ms_teams':
        case 'webex':  
        case 'gotomymeeting':
          computedUrl = eventDetails.location; // Assuming eventDetails.location has the meet URL
          setIsButtonVisible(true);
          break;
        case 'provide':
          computedUrl = isValidUrl(eventDetails.location) ? eventDetails.location : ''; // Check if there is a provided URL
          setIsButtonVisible(isValidUrl(eventDetails.location));
          break;
        default:
          computedUrl = `/myevents/edit/${eventDetails.id}`; // Default to the edit page
          setIsButtonVisible(true);
      }
return computedUrl
      // setRedirectUrl(computedUrl,isButtonVisible);
    }
  }

  return (
    <Tr border="1px solid #EBEBEB">
      <Td p={2} borderColor="#EBEBEB" whiteSpace="nowrap">
        <HStack>
          <Link
            href={
              type === 'past' && event.author.id === userProfileInfo?.id
                ? `/myevents/dashboard/${event?.id}`
                : `/myevents/details/${event?.id}`
            }
          >
            <Image
              src={event?.media[0]?.file}
              boxSize="50px"
              objectFit="cover"
              alt={event?.title}
              fallback={
                <Flex
                  p={2}
                  bg="#D9D9D9"
                  width="50px"
                  height="50px"
                  justifyContent="center"
                  alignItems="center"
                >
                  <CalendarIcon />
                </Flex>
              }
            />
          </Link>{' '}
          <Link
            href={
              type === 'past' && event.author.id === userProfileInfo?.id
                ? `/myevents/dashboard/${event?.id}`
                : `/myevents/details/${event?.id}`
            }
          >
            <Tooltip label={event?.title} aria-label="Event Title">
            <Text>{event.title?.length > 20 ? event.title?.slice(0, 20) + "..." : event.title}</Text>
            </Tooltip>
          </Link>
        </HStack>
      </Td>
      <Td p={2} borderColor="#EBEBEB" whiteSpace="nowrap">
        {event?.company?.name == "" ? (<HStack>
         
          <Avatar name={`${event?.author?.display_name}`} src={event?.author?.profile_pic} size="md" />
          <Text>{getUserFullName(event?.author)}</Text>
          </HStack>)
        : (<HStack>
          <Image
            src={event?.company?.image}
            boxSize="40px"
            objectFit="cover"
            alt={event?.company?.name}
            borderRadius="full"
          />
          <Text>{event?.company?.name}</Text>
          </HStack>) }
      </Td>
      <Td p={2} borderColor="#EBEBEB" whiteSpace="nowrap">
        {type === 'upcoming'
          ? moment(event.start_time).format('DD MMM YYYY')
          : moment(event.start_time).local().format('DD MMM YYYY')}
      </Td>
      <Td p={2} borderColor="#EBEBEB" whiteSpace="nowrap">
        {moment(event.start_time).local().format('hh:mm A')} -{' '}
        {moment(event.end_time).local().format('hh:mm A zz')}
      </Td>
      <Td p={2} borderColor="#EBEBEB" whiteSpace="nowrap">
        <HStack w="100%" justifyContent="flex-end" gap={0}>
          <Tooltip label={event?.event_type==='webinar'?"View webinar details":"View event details"} bg="#5B5B5B">
            <IconButton
              p={0}
              variant="transparent"
              icon={<EyeViewIcon width="16px" />}
              onClick={() => router.push(`/myevents/details/${event.id}`)}
            />
          </Tooltip>

          {event.author.id === userProfileInfo?.id && (
            <Tooltip label="View dashboard" bg="#5B5B5B">
              <IconButton
                p={0}
                variant="transparent"
                icon={<EventDashbaord width="16px" color="#2E2E2A" />}
                onClick={() => router.push(`/myevents/dashboard/${event.id}`)}
              />
            </Tooltip>
          )}

          {event.author.id === userProfileInfo?.id && type !== 'copy' && (
            <Tooltip label="Edit" bg="#5B5B5B">
              <IconButton
                p={0}
                variant="transparent"
                icon={<Pencil width="16px" />}
                onClick={() =>{router.push(`/myevents/edit/${event.id}`)}}
              />
            </Tooltip>
          )}
          {type === 'copy' && (
            <Button
              onClick={() => router.push(`/myevents/copy/${event.id}`)}
              size="sm"
              minW={'144px'}
              variant="primary"
              borderRadius="25px"
            >
              {event?.event_type==='webinar'?'Copy this webinar':'Copy this event'}
            </Button>
          )}


{type === 'upcoming'&&event.location_type==="builtin" ? (
            event.author.id === userProfileInfo?.id ? (
              <Button
                size="sm"
                variant="primary"
                borderRadius="25px"
                onClick={() =>{
                  if(event?.location_type==="builtin"){

                    router.push(`/myevents/join/${event.id}`)
                  }
                }}
              >
                Start
              </Button>
            ) : (
              <Button
                size="sm"
                variant="primary"
                borderRadius="25px"
                onClick={() => router.push(`/myevents/join/${event.id}`)}
              >
                Join
              </Button>
            )
          ) : (
            <></>
          )}



          {type === 'upcoming'&&event.location_type!=="builtin"&&isValidUrl(event.location??"") ? (
            event.author.id === userProfileInfo?.id ? (
              <Button
                size="sm"
                variant="primary"
                borderRadius="25px"
                onClick={() =>{
                  if(event?.location_type==="builtin"){

                    router.push(`/myevents/join/${event.id}`)
                  }else{
                   window.open(handleGetEventDetails(event))
                  }
                }}
              >
                Start
              </Button>
            ) : (
              <Button
                size="sm"
                variant="primary"
                borderRadius="25px"
                onClick={() => router.push(`/myevents/join/${event.id}`)}
              >
                Join
              </Button>
            )
          ) : (
            <></>
          )}
          {type !== 'copy' && (
            <Menu>
              <MenuButton
                as={IconButton}
                aria-label="Options"
                icon={<VerticalThreeDot height="19px" />}
                variant="transparent"
              />
              <MenuList>
                {event.author.id === userProfileInfo?.id && (
                  <MenuItem
                    onClick={() =>
                      router.push(`/myevents/dashboard/${event?.id}`)
                    }
                  >
                    Event Dashboard
                  </MenuItem>
                )}
                {type === 'past' && event.event_recording_url !== null ? (
                  <MenuItem
                  >
                    <Link href={event.event_recording_url} target='_blank'>
                      <Text>Recording</Text></Link>
                  </MenuItem>
                ) : <></>}
                {type === 'past'
                  ? event.author.id === userProfileInfo?.id && (
                    <MenuItem
                      onClick={() =>
                        router.push(`/myevents/copy/${event?.id}`)
                      }
                    >
                      Duplicate
                    </MenuItem>
                  )
                  : ''}
                <MenuItem onClick={() => handleDeleteEvent()}>Delete</MenuItem>
              </MenuList>
            </Menu>
          )}
        </HStack>
      </Td>
    </Tr>
  );
};

export default EventListRow;
